import { render, staticRenderFns } from "./EditBranchModal.vue?vue&type=template&id=d795a0b0&"
import script from "./EditBranchModal.vue?vue&type=script&lang=js&"
export * from "./EditBranchModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports